import React from 'react';

import classNames from 'classnames';

import { HawkWidgetContext } from '../HawkWidget/HawkWidgetContext';

import styles from './styles/load-more.css';

export interface LoadMoreProps {
  className?: string;
}

const LoadMore: React.FC<LoadMoreProps> = ({ className }) => (
  <HawkWidgetContext.Consumer>
    {(value): JSX.Element | null => {
      const { loadMoreDeals, showFewerDeals, activeTab, translate, loadMore, dealData } = value;
      const numDeals = dealData.deals.length;
      const canLoadMore = dealData.totalDeals > numDeals;
      const canShowFewer = numDeals > activeTab.pageSize;

      // Don't display if we can't fill the default rows
      if (!loadMore || dealData.totalDeals <= activeTab.pageSize) {
        return null;
      }

      return (
        <div className={classNames(styles.container, className && styles[className])}>
          <div className={styles.loadMoreContainer}>
            {canLoadMore ? (
              <button
                className={styles.loadMoreButton}
                type="button"
                onClick={(): void => loadMoreDeals(true)}
              >
                {translate('showMore')}
              </button>
            ) : (
              <span className={styles.noMoreResults}>{translate('noMoreResults')}</span>
            )}
          </div>
          {canShowFewer && (
            <div className={styles.showFewerContainer}>
              <button className={styles.showFewerButton} type="button" onClick={showFewerDeals}>
                {translate('showLess')}
              </button>
            </div>
          )}
        </div>
      );
    }}
  </HawkWidgetContext.Consumer>
);

export default LoadMore;
